import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-code-login-error',
    templateUrl: './code-login-error.component.html',
    styleUrls: ['./code-login-error.component.scss'],
    standalone: false
})
export class CodeLoginErrorComponent implements OnInit {
  title = '403';
  message = 'You are not allowed to perform this action.';

  constructor(private router: Router, private route: ActivatedRoute) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state as { message?: string; title?: string } | undefined;
    if (state?.message) {
      this.message = state.message;
    }
    if (state?.title) {
      this.title = state.title;
    }
  }

  ngOnInit(): void {
    const state = history.state as { message?: string; title?: string } | undefined;
    if (state?.message) {
      this.message = state.message;
    }
    if (state?.title) {
      this.title = state.title;
    }

    const queryMsg = this.route.snapshot.queryParamMap.get('message');
    if (queryMsg) {
      this.message = queryMsg;
    }
    const queryTitle = this.route.snapshot.queryParamMap.get('title');
    if (queryTitle) {
      this.title = queryTitle;
    }
  }

  backToHome(): void {
    this.router.navigate(['/']);
  }
}
